// stage of tutorial
const QUESTION_LIST = 'QUESTION_LIST';

export const stages = {
  QUESTION_LIST,
};

// types
export const TUTORIAL_QUESTION_IN_QUESTION_LIST =
  'TUTORIAL_QUESTION_IN_QUESTION_LIST';
export const TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST =
  'TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST';

export const QUESTION_LIST_STAGE_COUNT = 3;
export const STUDENT_CHAT_STAGE_COUNT = 4;
export const TUTOR_CHAT_STAGE_COUNT = 3;
export const STAGE_1 = 0;
export const STAGE_2 = 1;
export const STAGE_3 = 2;
export const STAGE_4 = 3;



// WEBPACK FOOTER //
// ./src/constants/tutorialSteps.js